// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "Streaming.proto" (package "streaming", syntax proto3)
// tslint:disable
import { Empty } from "./google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message streaming.ConnectRequest
 */
export interface ConnectRequest {
    /**
     * @generated from protobuf field: string application_id = 1;
     */
    applicationId: string; // contains the name of the application
    /**
     * @generated from protobuf field: string tenant_id = 2;
     */
    tenantId: string; // contains the id of the tenant
    /**
     * @generated from protobuf field: string session_id = 3;
     */
    sessionId: string; // contains the id of the session, persistent across reconnects
    /**
     * @generated from protobuf field: streaming.ConnectRequest.ConnectReason reason = 4;
     */
    reason: ConnectRequest_ConnectReason; // contains the reason for the connection
    /**
     * @generated from protobuf field: optional int64 time_since_first_connect = 5;
     */
    timeSinceFirstConnect?: bigint; // contains the time since the first connect in ms
    /**
     * @generated from protobuf field: streaming.ConnectRequest.BrowserInfo browser_info = 6;
     */
    browserInfo?: ConnectRequest_BrowserInfo; // contains the browser information
    /**
     * @generated from protobuf field: streaming.ConnectRequest.DeviceInfo device_info = 7;
     */
    deviceInfo?: ConnectRequest_DeviceInfo; // contains the device information
    /**
     * @generated from protobuf field: streaming.ConnectRequest.ConnectionInfo connection_info = 8;
     */
    connectionInfo?: ConnectRequest_ConnectionInfo; // contains the connection information
}
/**
 * @generated from protobuf message streaming.ConnectRequest.BrowserInfo
 */
export interface ConnectRequest_BrowserInfo {
    /**
     * @generated from protobuf field: string browser_name = 1;
     */
    browserName: string; // contains the browser name
    /**
     * @generated from protobuf field: string browser_version_major = 2;
     */
    browserVersionMajor: string; // contains the major browser version
    /**
     * @generated from protobuf field: string browser_version_full = 3;
     */
    browserVersionFull: string; // contains the full browser version
    /**
     * @generated from protobuf field: string engine_name = 4;
     */
    engineName: string; // contains the engine name
    /**
     * @generated from protobuf field: string engine_version = 5;
     */
    engineVersion: string; // contains the engine version
    /**
     * @generated from protobuf field: string user_agent = 6;
     */
    userAgent: string; // contains the user agent information
    /**
     * @generated from protobuf field: bool with_client_hints = 7;
     */
    withClientHints: boolean; // contains the flag if the browser supports client hints
}
/**
 * @generated from protobuf message streaming.ConnectRequest.DeviceInfo
 */
export interface ConnectRequest_DeviceInfo {
    /**
     * @generated from protobuf field: string os_name = 1;
     */
    osName: string; // contains the operating system name
    /**
     * @generated from protobuf field: string os_version = 2;
     */
    osVersion: string; // contains the operating system version
    /**
     * @generated from protobuf field: string architecture = 3;
     */
    architecture: string; // contains the architecture of the device
    /**
     * @generated from protobuf field: string type = 4;
     */
    type: string; // contains the form factor of the device
    /**
     * @generated from protobuf field: string vendor = 5;
     */
    vendor: string; // contains the vendor of the device
    /**
     * @generated from protobuf field: string model = 6;
     */
    model: string; // contains the model of the device
    /**
     * @generated from protobuf field: float memory = 7;
     */
    memory: number; // contains the memory of the device in gb
    /**
     * @generated from protobuf field: int32 cores = 8;
     */
    cores: number; // contains the number of cores of the device
    /**
     * @generated from protobuf field: int32 screen_width = 9;
     */
    screenWidth: number; // contains the width of the screen
    /**
     * @generated from protobuf field: int32 screen_height = 10;
     */
    screenHeight: number; // contains the height of the screen
    /**
     * @generated from protobuf field: float screen_dpr = 11;
     */
    screenDpr: number; // contains the device pixel ratio
}
/**
 * @generated from protobuf message streaming.ConnectRequest.ConnectionInfo
 */
export interface ConnectRequest_ConnectionInfo {
    /**
     * @generated from protobuf field: float rtt = 1;
     */
    rtt: number; // contains the round trip time in ms
    /**
     * @generated from protobuf field: float down_link = 2;
     */
    downLink: number; // contains the down link in mbps
    /**
     * @generated from protobuf field: string connection_type = 3;
     */
    connectionType: string; // contains the connection type
}
/**
 * @generated from protobuf enum streaming.ConnectRequest.ConnectReason
 */
export enum ConnectRequest_ConnectReason {
    /**
     * initial connection
     *
     * @generated from protobuf enum value: INITIAL = 0;
     */
    INITIAL = 0,
    /**
     * unknown reconnect reason
     *
     * @generated from protobuf enum value: RECONNECT_UNKNOWN = 1;
     */
    RECONNECT_UNKNOWN = 1,
    /**
     * a scheduled reconnect occurred
     *
     * @generated from protobuf enum value: RECONNECT_SCHEDULED = 2;
     */
    RECONNECT_SCHEDULED = 2,
    /**
     * a grpc error occurred
     *
     * @generated from protobuf enum value: RECONNECT_GRPC_ERROR = 3;
     */
    RECONNECT_GRPC_ERROR = 3,
    /**
     * ping timeout occurred
     *
     * @generated from protobuf enum value: RECONNECT_PING_TIMEOUT = 4;
     */
    RECONNECT_PING_TIMEOUT = 4
}
/**
 * @generated from protobuf message streaming.GrpcEvent
 */
export interface GrpcEvent {
    /**
     * @generated from protobuf field: string payload = 1;
     */
    payload: string; // contains the base64 encoded string data of a Streaming Event
    /**
     * @generated from protobuf field: string event_id = 2;
     */
    eventId: string; // contains the id of the event
    /**
     * @generated from protobuf field: int64 timestamp = 3;
     */
    timestamp: bigint; // contains the timestamp of the event
    /**
     * @generated from protobuf field: int64 retry_count = 4;
     */
    retryCount: bigint; // contains the retry count of the event
}
/**
 * @generated from protobuf message streaming.UpdateStateRequest
 */
export interface UpdateStateRequest {
    /**
     * @generated from protobuf field: string connection_id = 1;
     */
    connectionId: string; // contains the id of the connection
    /**
     * @generated from protobuf field: streaming.UpdateStateRequest.ConnectionState state = 2;
     */
    state: UpdateStateRequest_ConnectionState; // contains the state of the connection
    /**
     * @generated from protobuf field: int64 timestamp = 3;
     */
    timestamp: bigint; // contains the timestamp of the state change
}
/**
 * @generated from protobuf enum streaming.UpdateStateRequest.ConnectionState
 */
export enum UpdateStateRequest_ConnectionState {
    /**
     * connected state
     *
     * @generated from protobuf enum value: ACTIVE = 0;
     */
    ACTIVE = 0,
    /**
     * disconnected state
     *
     * @generated from protobuf enum value: SUSPENDED = 1;
     */
    SUSPENDED = 1
}
/**
 * @generated from protobuf message streaming.ConfirmRequest
 */
export interface ConfirmRequest {
    /**
     * @generated from protobuf field: string connection_id = 1;
     */
    connectionId: string; // contains the id of the connection
    /**
     * @generated from protobuf field: streaming.ConfirmRequest.Metrics metrics = 2;
     */
    metrics?: ConfirmRequest_Metrics; // contains the metrics of the connection
    /**
     * @generated from protobuf field: repeated streaming.ConfirmRequest.Event events = 3;
     */
    events: ConfirmRequest_Event[]; // contains the events to be confirmed
}
/**
 * @generated from protobuf message streaming.ConfirmRequest.Event
 */
export interface ConfirmRequest_Event {
    /**
     * @generated from protobuf field: string event_id = 1;
     */
    eventId: string; // id contains the id of the event
}
/**
 * @generated from protobuf message streaming.ConfirmRequest.Metrics
 */
export interface ConfirmRequest_Metrics {
    /**
     * @generated from protobuf field: streaming.ConfirmRequest.Metrics.GlobalMetrics global_metrics = 1;
     */
    globalMetrics?: ConfirmRequest_Metrics_GlobalMetrics; // contains the metrics counted from the start of the first connection
    /**
     * @generated from protobuf field: repeated streaming.ConfirmRequest.Metrics.TimeSlot time_slots = 2;
     */
    timeSlots: ConfirmRequest_Metrics_TimeSlot[]; // contains the time slots to be updated
    /**
     * @generated from protobuf field: repeated streaming.ConfirmRequest.Metrics.TimeFrame time_frames = 3;
     */
    timeFrames: ConfirmRequest_Metrics_TimeFrame[]; // contains the time frames with state changes
}
/**
 * @generated from protobuf message streaming.ConfirmRequest.Metrics.GlobalMetrics
 */
export interface ConfirmRequest_Metrics_GlobalMetrics {
    /**
     * @generated from protobuf field: int64 timestamp = 1;
     */
    timestamp: bigint; // contains the timestamp of the metric calculation (for versioning)
    /**
     * @generated from protobuf field: int32 received_ping_events = 2;
     */
    receivedPingEvents: number; // contains the total number of received ping events
    /**
     * @generated from protobuf field: int32 received_other_events = 3;
     */
    receivedOtherEvents: number; // contains the total number of received other events
    /**
     * @generated from protobuf field: int32 received_retried_events = 4;
     */
    receivedRetriedEvents: number; // contains the total number of received retried events
    /**
     * @generated from protobuf field: int32 confirmed_events = 5;
     */
    confirmedEvents: number; // contains the total number of confirmed events, including the ones in this request
    /**
     * @generated from protobuf field: int32 reconnects = 6;
     */
    reconnects: number; // contains the total number of reconnects
    /**
     * @generated from protobuf field: int32 base_delay = 7;
     */
    baseDelay: number; // contains the base delay in ms since the first connection
}
/**
 * @generated from protobuf message streaming.ConfirmRequest.Metrics.TimeSlot
 */
export interface ConfirmRequest_Metrics_TimeSlot {
    /**
     * @generated from protobuf field: int64 timestamp = 1;
     */
    timestamp: bigint; // contains the timestamp of the time slot calculation (for versioning)
    /**
     * @generated from protobuf field: int32 start = 2;
     */
    start: number; // contains the start timestamp of the time slot, relative to the first start of the connection
    /**
     * @generated from protobuf field: int32 end = 3;
     */
    end: number; // contains the end timestamp of the time slot, relative to the first start of the connection
    /**
     * @generated from protobuf field: int32 index = 4;
     */
    index: number; // contains the index of the time slot, calculated in 15s intervals from the start of the connection
    /**
     * @generated from protobuf field: int32 avg_delay = 5;
     */
    avgDelay: number; // contains the average delay in ms for this time slot
    /**
     * @generated from protobuf field: int32 spike_count_200ms = 6 [json_name = "spikeCount200ms"];
     */
    spikeCount200Ms: number; // contains the number of events with a delay > 200ms for this time slot
    /**
     * @generated from protobuf field: int32 spike_count_500ms = 7 [json_name = "spikeCount500ms"];
     */
    spikeCount500Ms: number; // contains the number of events with a delay > 500ms for this time slot
    /**
     * @generated from protobuf field: int32 spike_count_2000ms = 8 [json_name = "spikeCount2000ms"];
     */
    spikeCount2000Ms: number; // contains the number of events with a delay > 2000ms for this time slot
    /**
     * @generated from protobuf field: int32 received_ping_events = 9;
     */
    receivedPingEvents: number; // contains the number of received events for this time slot
    /**
     * @generated from protobuf field: int32 received_other_events = 10;
     */
    receivedOtherEvents: number; // contains the number of received other events for this time slot
    /**
     * @generated from protobuf field: int32 received_retried_events = 11;
     */
    receivedRetriedEvents: number; // contains the number of received retried events for this time slot
    /**
     * @generated from protobuf field: int32 reconnects = 12;
     */
    reconnects: number; // contains the number of reconnects for this time slot
    /**
     * @generated from protobuf field: repeated streaming.ConfirmRequest.Metrics.TimeSlot.Event events = 13;
     */
    events: ConfirmRequest_Metrics_TimeSlot_Event[]; // contains the events that happened in this time slot
}
/**
 * @generated from protobuf message streaming.ConfirmRequest.Metrics.TimeSlot.Event
 */
export interface ConfirmRequest_Metrics_TimeSlot_Event {
    /**
     * @generated from protobuf field: int64 timestamp = 1;
     */
    timestamp: bigint; // contains the timestamp of the event
    /**
     * @generated from protobuf field: streaming.ConfirmRequest.Metrics.TimeSlot.Event.EventType type = 2;
     */
    type: ConfirmRequest_Metrics_TimeSlot_Event_EventType; // contains the type of the event
}
/**
 * @generated from protobuf enum streaming.ConfirmRequest.Metrics.TimeSlot.Event.EventType
 */
export enum ConfirmRequest_Metrics_TimeSlot_Event_EventType {
    /**
     * signals a reconnect event with unknown reason
     *
     * @generated from protobuf enum value: RECONNECT_UNKNOWN = 0;
     */
    RECONNECT_UNKNOWN = 0,
    /**
     * signals a reconnect event with scheduled reason
     *
     * @generated from protobuf enum value: RECONNECT_SCHEDULED = 1;
     */
    RECONNECT_SCHEDULED = 1,
    /**
     * signals a reconnect event with grpc error reason
     *
     * @generated from protobuf enum value: RECONNECT_GRPC_ERROR = 2;
     */
    RECONNECT_GRPC_ERROR = 2,
    /**
     * signals a reconnect event with ping timeout reason
     *
     * @generated from protobuf enum value: RECONNECT_PING_TIMEOUT = 3;
     */
    RECONNECT_PING_TIMEOUT = 3
}
/**
 * @generated from protobuf message streaming.ConfirmRequest.Metrics.TimeFrame
 */
export interface ConfirmRequest_Metrics_TimeFrame {
    /**
     * @generated from protobuf field: int64 timestamp = 1;
     */
    timestamp: bigint; // contains the timestamp of the time frame calculation (for versioning)
    /**
     * @generated from protobuf field: int32 index = 2;
     */
    index: number; // contains the index of the time frame, which is an increasing number
    /**
     * @generated from protobuf field: int64 start = 3;
     */
    start: bigint; // contains the start timestamp of the time frame, relative to the first start of the connection
    /**
     * @generated from protobuf field: int64 end = 4;
     */
    end: bigint; // contains the end timestamp of the time frame, relative to the first start of the connection
    /**
     * @generated from protobuf field: streaming.ConfirmRequest.Metrics.TimeFrame.ConnectionState state = 5;
     */
    state: ConfirmRequest_Metrics_TimeFrame_ConnectionState; // contains the state of the connection
}
/**
 * @generated from protobuf enum streaming.ConfirmRequest.Metrics.TimeFrame.ConnectionState
 */
export enum ConfirmRequest_Metrics_TimeFrame_ConnectionState {
    /**
     * connected state
     *
     * @generated from protobuf enum value: ACTIVE = 0;
     */
    ACTIVE = 0,
    /**
     * disconnected state
     *
     * @generated from protobuf enum value: SUSPENDED = 1;
     */
    SUSPENDED = 1,
    /**
     * offline state
     *
     * @generated from protobuf enum value: OFFLINE = 2;
     */
    OFFLINE = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class ConnectRequest$Type extends MessageType<ConnectRequest> {
    constructor() {
        super("streaming.ConnectRequest", [
            { no: 1, name: "application_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "reason", kind: "enum", T: () => ["streaming.ConnectRequest.ConnectReason", ConnectRequest_ConnectReason] },
            { no: 5, name: "time_since_first_connect", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "browser_info", kind: "message", T: () => ConnectRequest_BrowserInfo },
            { no: 7, name: "device_info", kind: "message", T: () => ConnectRequest_DeviceInfo },
            { no: 8, name: "connection_info", kind: "message", T: () => ConnectRequest_ConnectionInfo }
        ]);
    }
    create(value?: PartialMessage<ConnectRequest>): ConnectRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.applicationId = "";
        message.tenantId = "";
        message.sessionId = "";
        message.reason = 0;
        if (value !== undefined)
            reflectionMergePartial<ConnectRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectRequest): ConnectRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string application_id */ 1:
                    message.applicationId = reader.string();
                    break;
                case /* string tenant_id */ 2:
                    message.tenantId = reader.string();
                    break;
                case /* string session_id */ 3:
                    message.sessionId = reader.string();
                    break;
                case /* streaming.ConnectRequest.ConnectReason reason */ 4:
                    message.reason = reader.int32();
                    break;
                case /* optional int64 time_since_first_connect */ 5:
                    message.timeSinceFirstConnect = reader.int64().toBigInt();
                    break;
                case /* streaming.ConnectRequest.BrowserInfo browser_info */ 6:
                    message.browserInfo = ConnectRequest_BrowserInfo.internalBinaryRead(reader, reader.uint32(), options, message.browserInfo);
                    break;
                case /* streaming.ConnectRequest.DeviceInfo device_info */ 7:
                    message.deviceInfo = ConnectRequest_DeviceInfo.internalBinaryRead(reader, reader.uint32(), options, message.deviceInfo);
                    break;
                case /* streaming.ConnectRequest.ConnectionInfo connection_info */ 8:
                    message.connectionInfo = ConnectRequest_ConnectionInfo.internalBinaryRead(reader, reader.uint32(), options, message.connectionInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string application_id = 1; */
        if (message.applicationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.applicationId);
        /* string tenant_id = 2; */
        if (message.tenantId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenantId);
        /* string session_id = 3; */
        if (message.sessionId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sessionId);
        /* streaming.ConnectRequest.ConnectReason reason = 4; */
        if (message.reason !== 0)
            writer.tag(4, WireType.Varint).int32(message.reason);
        /* optional int64 time_since_first_connect = 5; */
        if (message.timeSinceFirstConnect !== undefined)
            writer.tag(5, WireType.Varint).int64(message.timeSinceFirstConnect);
        /* streaming.ConnectRequest.BrowserInfo browser_info = 6; */
        if (message.browserInfo)
            ConnectRequest_BrowserInfo.internalBinaryWrite(message.browserInfo, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* streaming.ConnectRequest.DeviceInfo device_info = 7; */
        if (message.deviceInfo)
            ConnectRequest_DeviceInfo.internalBinaryWrite(message.deviceInfo, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* streaming.ConnectRequest.ConnectionInfo connection_info = 8; */
        if (message.connectionInfo)
            ConnectRequest_ConnectionInfo.internalBinaryWrite(message.connectionInfo, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message streaming.ConnectRequest
 */
export const ConnectRequest = new ConnectRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectRequest_BrowserInfo$Type extends MessageType<ConnectRequest_BrowserInfo> {
    constructor() {
        super("streaming.ConnectRequest.BrowserInfo", [
            { no: 1, name: "browser_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "browser_version_major", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "browser_version_full", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "engine_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "engine_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "user_agent", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "with_client_hints", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectRequest_BrowserInfo>): ConnectRequest_BrowserInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.browserName = "";
        message.browserVersionMajor = "";
        message.browserVersionFull = "";
        message.engineName = "";
        message.engineVersion = "";
        message.userAgent = "";
        message.withClientHints = false;
        if (value !== undefined)
            reflectionMergePartial<ConnectRequest_BrowserInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectRequest_BrowserInfo): ConnectRequest_BrowserInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string browser_name */ 1:
                    message.browserName = reader.string();
                    break;
                case /* string browser_version_major */ 2:
                    message.browserVersionMajor = reader.string();
                    break;
                case /* string browser_version_full */ 3:
                    message.browserVersionFull = reader.string();
                    break;
                case /* string engine_name */ 4:
                    message.engineName = reader.string();
                    break;
                case /* string engine_version */ 5:
                    message.engineVersion = reader.string();
                    break;
                case /* string user_agent */ 6:
                    message.userAgent = reader.string();
                    break;
                case /* bool with_client_hints */ 7:
                    message.withClientHints = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectRequest_BrowserInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string browser_name = 1; */
        if (message.browserName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.browserName);
        /* string browser_version_major = 2; */
        if (message.browserVersionMajor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.browserVersionMajor);
        /* string browser_version_full = 3; */
        if (message.browserVersionFull !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.browserVersionFull);
        /* string engine_name = 4; */
        if (message.engineName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.engineName);
        /* string engine_version = 5; */
        if (message.engineVersion !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.engineVersion);
        /* string user_agent = 6; */
        if (message.userAgent !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.userAgent);
        /* bool with_client_hints = 7; */
        if (message.withClientHints !== false)
            writer.tag(7, WireType.Varint).bool(message.withClientHints);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message streaming.ConnectRequest.BrowserInfo
 */
export const ConnectRequest_BrowserInfo = new ConnectRequest_BrowserInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectRequest_DeviceInfo$Type extends MessageType<ConnectRequest_DeviceInfo> {
    constructor() {
        super("streaming.ConnectRequest.DeviceInfo", [
            { no: 1, name: "os_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "os_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "architecture", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "vendor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "model", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "memory", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "cores", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "screen_width", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "screen_height", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "screen_dpr", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectRequest_DeviceInfo>): ConnectRequest_DeviceInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.osName = "";
        message.osVersion = "";
        message.architecture = "";
        message.type = "";
        message.vendor = "";
        message.model = "";
        message.memory = 0;
        message.cores = 0;
        message.screenWidth = 0;
        message.screenHeight = 0;
        message.screenDpr = 0;
        if (value !== undefined)
            reflectionMergePartial<ConnectRequest_DeviceInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectRequest_DeviceInfo): ConnectRequest_DeviceInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string os_name */ 1:
                    message.osName = reader.string();
                    break;
                case /* string os_version */ 2:
                    message.osVersion = reader.string();
                    break;
                case /* string architecture */ 3:
                    message.architecture = reader.string();
                    break;
                case /* string type */ 4:
                    message.type = reader.string();
                    break;
                case /* string vendor */ 5:
                    message.vendor = reader.string();
                    break;
                case /* string model */ 6:
                    message.model = reader.string();
                    break;
                case /* float memory */ 7:
                    message.memory = reader.float();
                    break;
                case /* int32 cores */ 8:
                    message.cores = reader.int32();
                    break;
                case /* int32 screen_width */ 9:
                    message.screenWidth = reader.int32();
                    break;
                case /* int32 screen_height */ 10:
                    message.screenHeight = reader.int32();
                    break;
                case /* float screen_dpr */ 11:
                    message.screenDpr = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectRequest_DeviceInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string os_name = 1; */
        if (message.osName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.osName);
        /* string os_version = 2; */
        if (message.osVersion !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.osVersion);
        /* string architecture = 3; */
        if (message.architecture !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.architecture);
        /* string type = 4; */
        if (message.type !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.type);
        /* string vendor = 5; */
        if (message.vendor !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.vendor);
        /* string model = 6; */
        if (message.model !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.model);
        /* float memory = 7; */
        if (message.memory !== 0)
            writer.tag(7, WireType.Bit32).float(message.memory);
        /* int32 cores = 8; */
        if (message.cores !== 0)
            writer.tag(8, WireType.Varint).int32(message.cores);
        /* int32 screen_width = 9; */
        if (message.screenWidth !== 0)
            writer.tag(9, WireType.Varint).int32(message.screenWidth);
        /* int32 screen_height = 10; */
        if (message.screenHeight !== 0)
            writer.tag(10, WireType.Varint).int32(message.screenHeight);
        /* float screen_dpr = 11; */
        if (message.screenDpr !== 0)
            writer.tag(11, WireType.Bit32).float(message.screenDpr);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message streaming.ConnectRequest.DeviceInfo
 */
export const ConnectRequest_DeviceInfo = new ConnectRequest_DeviceInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectRequest_ConnectionInfo$Type extends MessageType<ConnectRequest_ConnectionInfo> {
    constructor() {
        super("streaming.ConnectRequest.ConnectionInfo", [
            { no: 1, name: "rtt", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 2, name: "down_link", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "connection_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectRequest_ConnectionInfo>): ConnectRequest_ConnectionInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.rtt = 0;
        message.downLink = 0;
        message.connectionType = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectRequest_ConnectionInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectRequest_ConnectionInfo): ConnectRequest_ConnectionInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* float rtt */ 1:
                    message.rtt = reader.float();
                    break;
                case /* float down_link */ 2:
                    message.downLink = reader.float();
                    break;
                case /* string connection_type */ 3:
                    message.connectionType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectRequest_ConnectionInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* float rtt = 1; */
        if (message.rtt !== 0)
            writer.tag(1, WireType.Bit32).float(message.rtt);
        /* float down_link = 2; */
        if (message.downLink !== 0)
            writer.tag(2, WireType.Bit32).float(message.downLink);
        /* string connection_type = 3; */
        if (message.connectionType !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.connectionType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message streaming.ConnectRequest.ConnectionInfo
 */
export const ConnectRequest_ConnectionInfo = new ConnectRequest_ConnectionInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrpcEvent$Type extends MessageType<GrpcEvent> {
    constructor() {
        super("streaming.GrpcEvent", [
            { no: 1, name: "payload", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "timestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "retry_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<GrpcEvent>): GrpcEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.payload = "";
        message.eventId = "";
        message.timestamp = 0n;
        message.retryCount = 0n;
        if (value !== undefined)
            reflectionMergePartial<GrpcEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrpcEvent): GrpcEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string payload */ 1:
                    message.payload = reader.string();
                    break;
                case /* string event_id */ 2:
                    message.eventId = reader.string();
                    break;
                case /* int64 timestamp */ 3:
                    message.timestamp = reader.int64().toBigInt();
                    break;
                case /* int64 retry_count */ 4:
                    message.retryCount = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrpcEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string payload = 1; */
        if (message.payload !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.payload);
        /* string event_id = 2; */
        if (message.eventId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.eventId);
        /* int64 timestamp = 3; */
        if (message.timestamp !== 0n)
            writer.tag(3, WireType.Varint).int64(message.timestamp);
        /* int64 retry_count = 4; */
        if (message.retryCount !== 0n)
            writer.tag(4, WireType.Varint).int64(message.retryCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message streaming.GrpcEvent
 */
export const GrpcEvent = new GrpcEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStateRequest$Type extends MessageType<UpdateStateRequest> {
    constructor() {
        super("streaming.UpdateStateRequest", [
            { no: 1, name: "connection_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "state", kind: "enum", T: () => ["streaming.UpdateStateRequest.ConnectionState", UpdateStateRequest_ConnectionState] },
            { no: 3, name: "timestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateStateRequest>): UpdateStateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.connectionId = "";
        message.state = 0;
        message.timestamp = 0n;
        if (value !== undefined)
            reflectionMergePartial<UpdateStateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateStateRequest): UpdateStateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string connection_id */ 1:
                    message.connectionId = reader.string();
                    break;
                case /* streaming.UpdateStateRequest.ConnectionState state */ 2:
                    message.state = reader.int32();
                    break;
                case /* int64 timestamp */ 3:
                    message.timestamp = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateStateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string connection_id = 1; */
        if (message.connectionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.connectionId);
        /* streaming.UpdateStateRequest.ConnectionState state = 2; */
        if (message.state !== 0)
            writer.tag(2, WireType.Varint).int32(message.state);
        /* int64 timestamp = 3; */
        if (message.timestamp !== 0n)
            writer.tag(3, WireType.Varint).int64(message.timestamp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message streaming.UpdateStateRequest
 */
export const UpdateStateRequest = new UpdateStateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfirmRequest$Type extends MessageType<ConfirmRequest> {
    constructor() {
        super("streaming.ConfirmRequest", [
            { no: 1, name: "connection_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "metrics", kind: "message", T: () => ConfirmRequest_Metrics },
            { no: 3, name: "events", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ConfirmRequest_Event }
        ]);
    }
    create(value?: PartialMessage<ConfirmRequest>): ConfirmRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.connectionId = "";
        message.events = [];
        if (value !== undefined)
            reflectionMergePartial<ConfirmRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConfirmRequest): ConfirmRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string connection_id */ 1:
                    message.connectionId = reader.string();
                    break;
                case /* streaming.ConfirmRequest.Metrics metrics */ 2:
                    message.metrics = ConfirmRequest_Metrics.internalBinaryRead(reader, reader.uint32(), options, message.metrics);
                    break;
                case /* repeated streaming.ConfirmRequest.Event events */ 3:
                    message.events.push(ConfirmRequest_Event.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConfirmRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string connection_id = 1; */
        if (message.connectionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.connectionId);
        /* streaming.ConfirmRequest.Metrics metrics = 2; */
        if (message.metrics)
            ConfirmRequest_Metrics.internalBinaryWrite(message.metrics, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated streaming.ConfirmRequest.Event events = 3; */
        for (let i = 0; i < message.events.length; i++)
            ConfirmRequest_Event.internalBinaryWrite(message.events[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message streaming.ConfirmRequest
 */
export const ConfirmRequest = new ConfirmRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfirmRequest_Event$Type extends MessageType<ConfirmRequest_Event> {
    constructor() {
        super("streaming.ConfirmRequest.Event", [
            { no: 1, name: "event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConfirmRequest_Event>): ConfirmRequest_Event {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.eventId = "";
        if (value !== undefined)
            reflectionMergePartial<ConfirmRequest_Event>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConfirmRequest_Event): ConfirmRequest_Event {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string event_id */ 1:
                    message.eventId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConfirmRequest_Event, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string event_id = 1; */
        if (message.eventId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.eventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message streaming.ConfirmRequest.Event
 */
export const ConfirmRequest_Event = new ConfirmRequest_Event$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfirmRequest_Metrics$Type extends MessageType<ConfirmRequest_Metrics> {
    constructor() {
        super("streaming.ConfirmRequest.Metrics", [
            { no: 1, name: "global_metrics", kind: "message", T: () => ConfirmRequest_Metrics_GlobalMetrics },
            { no: 2, name: "time_slots", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ConfirmRequest_Metrics_TimeSlot },
            { no: 3, name: "time_frames", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ConfirmRequest_Metrics_TimeFrame }
        ]);
    }
    create(value?: PartialMessage<ConfirmRequest_Metrics>): ConfirmRequest_Metrics {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.timeSlots = [];
        message.timeFrames = [];
        if (value !== undefined)
            reflectionMergePartial<ConfirmRequest_Metrics>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConfirmRequest_Metrics): ConfirmRequest_Metrics {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* streaming.ConfirmRequest.Metrics.GlobalMetrics global_metrics */ 1:
                    message.globalMetrics = ConfirmRequest_Metrics_GlobalMetrics.internalBinaryRead(reader, reader.uint32(), options, message.globalMetrics);
                    break;
                case /* repeated streaming.ConfirmRequest.Metrics.TimeSlot time_slots */ 2:
                    message.timeSlots.push(ConfirmRequest_Metrics_TimeSlot.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated streaming.ConfirmRequest.Metrics.TimeFrame time_frames */ 3:
                    message.timeFrames.push(ConfirmRequest_Metrics_TimeFrame.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConfirmRequest_Metrics, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* streaming.ConfirmRequest.Metrics.GlobalMetrics global_metrics = 1; */
        if (message.globalMetrics)
            ConfirmRequest_Metrics_GlobalMetrics.internalBinaryWrite(message.globalMetrics, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated streaming.ConfirmRequest.Metrics.TimeSlot time_slots = 2; */
        for (let i = 0; i < message.timeSlots.length; i++)
            ConfirmRequest_Metrics_TimeSlot.internalBinaryWrite(message.timeSlots[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated streaming.ConfirmRequest.Metrics.TimeFrame time_frames = 3; */
        for (let i = 0; i < message.timeFrames.length; i++)
            ConfirmRequest_Metrics_TimeFrame.internalBinaryWrite(message.timeFrames[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message streaming.ConfirmRequest.Metrics
 */
export const ConfirmRequest_Metrics = new ConfirmRequest_Metrics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfirmRequest_Metrics_GlobalMetrics$Type extends MessageType<ConfirmRequest_Metrics_GlobalMetrics> {
    constructor() {
        super("streaming.ConfirmRequest.Metrics.GlobalMetrics", [
            { no: 1, name: "timestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "received_ping_events", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "received_other_events", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "received_retried_events", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "confirmed_events", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "reconnects", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "base_delay", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ConfirmRequest_Metrics_GlobalMetrics>): ConfirmRequest_Metrics_GlobalMetrics {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.timestamp = 0n;
        message.receivedPingEvents = 0;
        message.receivedOtherEvents = 0;
        message.receivedRetriedEvents = 0;
        message.confirmedEvents = 0;
        message.reconnects = 0;
        message.baseDelay = 0;
        if (value !== undefined)
            reflectionMergePartial<ConfirmRequest_Metrics_GlobalMetrics>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConfirmRequest_Metrics_GlobalMetrics): ConfirmRequest_Metrics_GlobalMetrics {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 timestamp */ 1:
                    message.timestamp = reader.int64().toBigInt();
                    break;
                case /* int32 received_ping_events */ 2:
                    message.receivedPingEvents = reader.int32();
                    break;
                case /* int32 received_other_events */ 3:
                    message.receivedOtherEvents = reader.int32();
                    break;
                case /* int32 received_retried_events */ 4:
                    message.receivedRetriedEvents = reader.int32();
                    break;
                case /* int32 confirmed_events */ 5:
                    message.confirmedEvents = reader.int32();
                    break;
                case /* int32 reconnects */ 6:
                    message.reconnects = reader.int32();
                    break;
                case /* int32 base_delay */ 7:
                    message.baseDelay = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConfirmRequest_Metrics_GlobalMetrics, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 timestamp = 1; */
        if (message.timestamp !== 0n)
            writer.tag(1, WireType.Varint).int64(message.timestamp);
        /* int32 received_ping_events = 2; */
        if (message.receivedPingEvents !== 0)
            writer.tag(2, WireType.Varint).int32(message.receivedPingEvents);
        /* int32 received_other_events = 3; */
        if (message.receivedOtherEvents !== 0)
            writer.tag(3, WireType.Varint).int32(message.receivedOtherEvents);
        /* int32 received_retried_events = 4; */
        if (message.receivedRetriedEvents !== 0)
            writer.tag(4, WireType.Varint).int32(message.receivedRetriedEvents);
        /* int32 confirmed_events = 5; */
        if (message.confirmedEvents !== 0)
            writer.tag(5, WireType.Varint).int32(message.confirmedEvents);
        /* int32 reconnects = 6; */
        if (message.reconnects !== 0)
            writer.tag(6, WireType.Varint).int32(message.reconnects);
        /* int32 base_delay = 7; */
        if (message.baseDelay !== 0)
            writer.tag(7, WireType.Varint).int32(message.baseDelay);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message streaming.ConfirmRequest.Metrics.GlobalMetrics
 */
export const ConfirmRequest_Metrics_GlobalMetrics = new ConfirmRequest_Metrics_GlobalMetrics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfirmRequest_Metrics_TimeSlot$Type extends MessageType<ConfirmRequest_Metrics_TimeSlot> {
    constructor() {
        super("streaming.ConfirmRequest.Metrics.TimeSlot", [
            { no: 1, name: "timestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "start", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "end", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "index", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "avg_delay", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "spike_count_200ms", kind: "scalar", jsonName: "spikeCount200ms", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "spike_count_500ms", kind: "scalar", jsonName: "spikeCount500ms", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "spike_count_2000ms", kind: "scalar", jsonName: "spikeCount2000ms", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "received_ping_events", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "received_other_events", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "received_retried_events", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "reconnects", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "events", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ConfirmRequest_Metrics_TimeSlot_Event }
        ]);
    }
    create(value?: PartialMessage<ConfirmRequest_Metrics_TimeSlot>): ConfirmRequest_Metrics_TimeSlot {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.timestamp = 0n;
        message.start = 0;
        message.end = 0;
        message.index = 0;
        message.avgDelay = 0;
        message.spikeCount200Ms = 0;
        message.spikeCount500Ms = 0;
        message.spikeCount2000Ms = 0;
        message.receivedPingEvents = 0;
        message.receivedOtherEvents = 0;
        message.receivedRetriedEvents = 0;
        message.reconnects = 0;
        message.events = [];
        if (value !== undefined)
            reflectionMergePartial<ConfirmRequest_Metrics_TimeSlot>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConfirmRequest_Metrics_TimeSlot): ConfirmRequest_Metrics_TimeSlot {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 timestamp */ 1:
                    message.timestamp = reader.int64().toBigInt();
                    break;
                case /* int32 start */ 2:
                    message.start = reader.int32();
                    break;
                case /* int32 end */ 3:
                    message.end = reader.int32();
                    break;
                case /* int32 index */ 4:
                    message.index = reader.int32();
                    break;
                case /* int32 avg_delay */ 5:
                    message.avgDelay = reader.int32();
                    break;
                case /* int32 spike_count_200ms = 6 [json_name = "spikeCount200ms"];*/ 6:
                    message.spikeCount200Ms = reader.int32();
                    break;
                case /* int32 spike_count_500ms = 7 [json_name = "spikeCount500ms"];*/ 7:
                    message.spikeCount500Ms = reader.int32();
                    break;
                case /* int32 spike_count_2000ms = 8 [json_name = "spikeCount2000ms"];*/ 8:
                    message.spikeCount2000Ms = reader.int32();
                    break;
                case /* int32 received_ping_events */ 9:
                    message.receivedPingEvents = reader.int32();
                    break;
                case /* int32 received_other_events */ 10:
                    message.receivedOtherEvents = reader.int32();
                    break;
                case /* int32 received_retried_events */ 11:
                    message.receivedRetriedEvents = reader.int32();
                    break;
                case /* int32 reconnects */ 12:
                    message.reconnects = reader.int32();
                    break;
                case /* repeated streaming.ConfirmRequest.Metrics.TimeSlot.Event events */ 13:
                    message.events.push(ConfirmRequest_Metrics_TimeSlot_Event.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConfirmRequest_Metrics_TimeSlot, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 timestamp = 1; */
        if (message.timestamp !== 0n)
            writer.tag(1, WireType.Varint).int64(message.timestamp);
        /* int32 start = 2; */
        if (message.start !== 0)
            writer.tag(2, WireType.Varint).int32(message.start);
        /* int32 end = 3; */
        if (message.end !== 0)
            writer.tag(3, WireType.Varint).int32(message.end);
        /* int32 index = 4; */
        if (message.index !== 0)
            writer.tag(4, WireType.Varint).int32(message.index);
        /* int32 avg_delay = 5; */
        if (message.avgDelay !== 0)
            writer.tag(5, WireType.Varint).int32(message.avgDelay);
        /* int32 spike_count_200ms = 6 [json_name = "spikeCount200ms"]; */
        if (message.spikeCount200Ms !== 0)
            writer.tag(6, WireType.Varint).int32(message.spikeCount200Ms);
        /* int32 spike_count_500ms = 7 [json_name = "spikeCount500ms"]; */
        if (message.spikeCount500Ms !== 0)
            writer.tag(7, WireType.Varint).int32(message.spikeCount500Ms);
        /* int32 spike_count_2000ms = 8 [json_name = "spikeCount2000ms"]; */
        if (message.spikeCount2000Ms !== 0)
            writer.tag(8, WireType.Varint).int32(message.spikeCount2000Ms);
        /* int32 received_ping_events = 9; */
        if (message.receivedPingEvents !== 0)
            writer.tag(9, WireType.Varint).int32(message.receivedPingEvents);
        /* int32 received_other_events = 10; */
        if (message.receivedOtherEvents !== 0)
            writer.tag(10, WireType.Varint).int32(message.receivedOtherEvents);
        /* int32 received_retried_events = 11; */
        if (message.receivedRetriedEvents !== 0)
            writer.tag(11, WireType.Varint).int32(message.receivedRetriedEvents);
        /* int32 reconnects = 12; */
        if (message.reconnects !== 0)
            writer.tag(12, WireType.Varint).int32(message.reconnects);
        /* repeated streaming.ConfirmRequest.Metrics.TimeSlot.Event events = 13; */
        for (let i = 0; i < message.events.length; i++)
            ConfirmRequest_Metrics_TimeSlot_Event.internalBinaryWrite(message.events[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message streaming.ConfirmRequest.Metrics.TimeSlot
 */
export const ConfirmRequest_Metrics_TimeSlot = new ConfirmRequest_Metrics_TimeSlot$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfirmRequest_Metrics_TimeSlot_Event$Type extends MessageType<ConfirmRequest_Metrics_TimeSlot_Event> {
    constructor() {
        super("streaming.ConfirmRequest.Metrics.TimeSlot.Event", [
            { no: 1, name: "timestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["streaming.ConfirmRequest.Metrics.TimeSlot.Event.EventType", ConfirmRequest_Metrics_TimeSlot_Event_EventType] }
        ]);
    }
    create(value?: PartialMessage<ConfirmRequest_Metrics_TimeSlot_Event>): ConfirmRequest_Metrics_TimeSlot_Event {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.timestamp = 0n;
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<ConfirmRequest_Metrics_TimeSlot_Event>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConfirmRequest_Metrics_TimeSlot_Event): ConfirmRequest_Metrics_TimeSlot_Event {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 timestamp */ 1:
                    message.timestamp = reader.int64().toBigInt();
                    break;
                case /* streaming.ConfirmRequest.Metrics.TimeSlot.Event.EventType type */ 2:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConfirmRequest_Metrics_TimeSlot_Event, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 timestamp = 1; */
        if (message.timestamp !== 0n)
            writer.tag(1, WireType.Varint).int64(message.timestamp);
        /* streaming.ConfirmRequest.Metrics.TimeSlot.Event.EventType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message streaming.ConfirmRequest.Metrics.TimeSlot.Event
 */
export const ConfirmRequest_Metrics_TimeSlot_Event = new ConfirmRequest_Metrics_TimeSlot_Event$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfirmRequest_Metrics_TimeFrame$Type extends MessageType<ConfirmRequest_Metrics_TimeFrame> {
    constructor() {
        super("streaming.ConfirmRequest.Metrics.TimeFrame", [
            { no: 1, name: "timestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "index", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "start", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "end", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "state", kind: "enum", T: () => ["streaming.ConfirmRequest.Metrics.TimeFrame.ConnectionState", ConfirmRequest_Metrics_TimeFrame_ConnectionState] }
        ]);
    }
    create(value?: PartialMessage<ConfirmRequest_Metrics_TimeFrame>): ConfirmRequest_Metrics_TimeFrame {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.timestamp = 0n;
        message.index = 0;
        message.start = 0n;
        message.end = 0n;
        message.state = 0;
        if (value !== undefined)
            reflectionMergePartial<ConfirmRequest_Metrics_TimeFrame>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConfirmRequest_Metrics_TimeFrame): ConfirmRequest_Metrics_TimeFrame {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 timestamp */ 1:
                    message.timestamp = reader.int64().toBigInt();
                    break;
                case /* int32 index */ 2:
                    message.index = reader.int32();
                    break;
                case /* int64 start */ 3:
                    message.start = reader.int64().toBigInt();
                    break;
                case /* int64 end */ 4:
                    message.end = reader.int64().toBigInt();
                    break;
                case /* streaming.ConfirmRequest.Metrics.TimeFrame.ConnectionState state */ 5:
                    message.state = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConfirmRequest_Metrics_TimeFrame, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 timestamp = 1; */
        if (message.timestamp !== 0n)
            writer.tag(1, WireType.Varint).int64(message.timestamp);
        /* int32 index = 2; */
        if (message.index !== 0)
            writer.tag(2, WireType.Varint).int32(message.index);
        /* int64 start = 3; */
        if (message.start !== 0n)
            writer.tag(3, WireType.Varint).int64(message.start);
        /* int64 end = 4; */
        if (message.end !== 0n)
            writer.tag(4, WireType.Varint).int64(message.end);
        /* streaming.ConfirmRequest.Metrics.TimeFrame.ConnectionState state = 5; */
        if (message.state !== 0)
            writer.tag(5, WireType.Varint).int32(message.state);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message streaming.ConfirmRequest.Metrics.TimeFrame
 */
export const ConfirmRequest_Metrics_TimeFrame = new ConfirmRequest_Metrics_TimeFrame$Type();
/**
 * @generated ServiceType for protobuf service streaming.OpenStreamingConnectionService
 */
export const OpenStreamingConnectionService = new ServiceType("streaming.OpenStreamingConnectionService", [
    { name: "connect", serverStreaming: true, options: {}, I: ConnectRequest, O: GrpcEvent }
]);
/**
 * @generated ServiceType for protobuf service streaming.UpdateConnectionStateService
 */
export const UpdateConnectionStateService = new ServiceType("streaming.UpdateConnectionStateService", [
    { name: "update", options: {}, I: UpdateStateRequest, O: Empty }
]);
/**
 * @generated ServiceType for protobuf service streaming.ConfirmStreamingEventsService
 */
export const ConfirmStreamingEventsService = new ServiceType("streaming.ConfirmStreamingEventsService", [
    { name: "confirm", options: {}, I: ConfirmRequest, O: Empty }
]);
